import React from "react";
import PropTypes from "prop-types";
import Typography from "./ui/Typography";
import { cn } from "../utils/classNames";

const UtilityPageIntro = ({
  title,
  description = "",
  actions = null,
  children = null,
  className = "",
}) => {
  return (
    <section
      className={cn(
        "utility-page-intro",
        className
      )}
    >
      <div className="utility-page-intro__layout">
        <div className="max-w-3xl space-y-2">
          <Typography as="h1" variant="h2" className="text-foreground">
            {title}
          </Typography>
          {description && (
            <Typography variant="body" className="reading-measure text-body text-muted-foreground sm:text-body-large">
              {description}
            </Typography>
          )}
        </div>

        <div className="utility-page-intro__aside">
          {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
          {children}
        </div>
      </div>
    </section>
  );
};

UtilityPageIntro.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default UtilityPageIntro;
